import { useState } from "react";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { AccountBox, AccountCircle, Logout } from "@mui/icons-material";
import {
  AppBar,
  Stack,
  Link,
  Toolbar,
  Typography,
  Button,
} from "@mui/material";
import { LoginService } from "../../login/api/LoginService";
import {
  LoginRequest,
} from "../../login/api/LoginForm";
import { useCookies } from "react-cookie";
import { ApplicationProtectedRouting, ApplicationPublicRouting } from "../../../Routing";
import Constants from "../../../utils/Constants";

const Header = () => {
  const navigate = useNavigate();
  const SYSTEM_NAME = "MDM契約管理システム";

  /***************************************************************
   * State管理
   **************************************************************/
  const [cookies, setCookie, removeCookie] = useCookies([
    "userId",
    "userContract",
    "date",
    "token",
    "maxage",
  ]);

  const [user, setUser] = useState(cookies.userContract);

  // リクエスト情報
  const [request, setRequest] = useState<LoginRequest>({
    username: "",
    password: "",
  });

  const deleteCookie = () => {
    removeCookie("userId");
    removeCookie("userContract");
    removeCookie("date");
    removeCookie("token");
    removeCookie("maxage");
  };
  // システム名
  const SystemName = useMemo(() => {
    return (
      <Typography variant="h1" fontSize={"1.5rem"}>
        <Link href={ApplicationProtectedRouting.contract.path()} color={"white"} underline={"none"}>
          {SYSTEM_NAME}
        </Link>
      </Typography>
    );
  }, []);

  // ユーザー名
  const userName = useMemo(() => {
    return (
      <>
        <AccountBox />：{user}
        <Typography component="p"></Typography>
      </>
    );
  }, [user]);

  // ログアウトAPI
  const onLogout = () => {
    const service = new LoginService();
    service.logout(request).finally(() => {
      deleteCookie();
      navigate(ApplicationPublicRouting.login.path());
    });
  };

  // ログアウトボタン
  const logoutButton = useMemo(() => {
    return (
      <Button color="inherit" onClick={onLogout}>
        <Logout />
        ログアウト
      </Button>
    );
  }, []);

  // ヘッダー左部
  const HeaderLeft = useMemo(() => {
    return <>{SystemName}</>;
  }, []);

  // ヘッダー右部
  const HeaderRight = useMemo(() => {
    return (
      <>
        <Stack direction="row" spacing={2} alignItems="center">
          {userName}
          {logoutButton}
        </Stack>
      </>
    );
  }, [userName, logoutButton]);

  return (
    <AppBar position="fixed">
      <Toolbar sx={{ justifyContent: "space-between", minHeight: Constants.HEADER_HEIGHT }}>
        {HeaderLeft}
        {HeaderRight}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
